export const hubRates = [
    {
        code: 'MB',
        label: 'Standard Room Type',
        text: 'Compact rooms, designed around you. From the luxurious Hypnos bed to monsoon shower, 40" Smart TV to pull out desk and under bed storage – everything is crafted for your comfort and entertainment. Like the control panel for adjusting the lights and temperature',
    },
    {
        code: 'MBS',
        label: 'Standard Room Type',
        text: 'Compact rooms, designed around you. From the luxurious Hypnos bed to monsoon shower, 40" Smart TV to pull out desk and under bed storage – everything is crafted for your comfort and entertainment. Like the control panel for adjusting the lights and temperature',
    },
    {
        code: 'GB',
        label: 'Bigger Room Type',
        text: 'All the clever design, entertainment and comfort of our standard room just a bit, well, bigger. There’s extra space, a luxurious king size Hypnos bed, a 40” Smart TV, desk and chair, refreshing monsoon shower and control panel to adjust the temperature and lights',
    },
    {
        code: 'GBS',
        label: 'Bigger Room Type',
        text: 'All the clever design, entertainment and comfort of our standard room just a bit, well, bigger. There’s extra space, a luxurious king size Hypnos bed, a 40” Smart TV, desk and chair, refreshing monsoon shower and control panel to adjust the temperature and lights',
    },
    {
        code: 'BB',
        label: 'Accessible Room Type',
        text: 'Everything you need, nothing you don\'t. Like all our rooms, our accessible rooms are designed around you. There\'s more space for easy wheelchair access, a wet room instead of a shower cubicle and controls and fixtures adjusted for comfort',
    },
    {
        code: 'BBS',
        label: 'Accessible Room Type',
        text: 'Everything you need, nothing you don\'t. Like all our rooms, our accessible rooms are designed around you. There\'s more space for easy wheelchair access, a wet room instead of a shower cubicle and controls and fixtures adjusted for comfort',
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-details/hub-rates-enum.js